module.exports = {
	"config": {
		"siteTitle": "JSConf Iceland: August 25th — 26th 2016",
		"siteDescription": "A two day JavaScript conference in Reykjavik, Iceland.",
		"sponsors": [
			{
				"name": "Advania",
				"website": "https://advania.is",
				"level": "platinum",
				"image": "advania.png",
				"imagePadding": true
			},
			{
				"name": "AMP Project",
				"website": "https://www.ampproject.org",
				"level": "platinum",
				"image": "google.png",
				"imagePadding": true
			},
			{
				"name": "Aranja",
				"website": "https://aranja.com",
				"level": "silver",
				"image": "aranja.svg",
				"imagePadding": false
			},
			{
				"name": "Bloomberg",
				"website": "https://bloomberg.com",
				"level": "silver",
				"image": "bloomberg.svg",
				"imagePadding": true
			},
			{
				"name": "CCP",
				"website": "https://ccpgames.com",
				"level": "bronze",
				"image": "ccp.png",
				"imagePadding": true
			},
			{
				"name": "Highcharts",
				"website": "https://highcharts.com",
				"level": "silver",
				"image": "highcharts.png",
				"imagePadding": true
			},
			{
				"name": "Landsbankinn",
				"website": "https://www.landsbankinn.is",
				"level": "silver",
				"image": "landsbankinn.jpg",
				"imagePadding": false
			},
			{
				"name": "Mozilla",
				"website": "https://www.mozilla.org",
				"level": "silver",
				"image": "mozilla.svg",
				"imagePadding": true
			},
			{
				"name": "Tempo",
				"website": "http://tempo.io",
				"level": "silver",
				"image": "tempo.svg",
				"imagePadding": true
			},
			{
				"name": "UENO.",
				"website": "https://ueno.co/",
				"level": "bronze",
				"image": "ueno.png",
				"imagePadding": false
			},
			{
				"name": "UPPERQUAD",
				"website": "http://upperquad.com/",
				"level": "silver",
				"image": "upperquad.png",
				"imagePadding": true
			},
			{
				"name": "VIEW SOURCE",
				"website": "https://viewsourceconf.org/",
				"level": "bronze",
				"image": "viewsourceconf.jpg",
				"imagePadding": false
			}
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_about.md",
				"ext": "md",
				"name": "_about",
				"extname": ".md",
				"basename": "_about.md",
				"dirname": "",
				"stem": "_about",
				"path": "_about.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/_about.md",
				"isAbsolute": false
			},
			"requirePath": "_about.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_cfp.md",
				"ext": "md",
				"name": "_cfp",
				"extname": ".md",
				"basename": "_cfp.md",
				"dirname": "",
				"stem": "_cfp",
				"path": "_cfp.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/_cfp.md",
				"isAbsolute": false
			},
			"requirePath": "_cfp.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_trips.md",
				"ext": "md",
				"name": "_trips",
				"extname": ".md",
				"basename": "_trips.md",
				"dirname": "",
				"stem": "_trips",
				"path": "_trips.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/_trips.md",
				"isAbsolute": false
			},
			"requirePath": "_trips.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.jsx",
				"ext": "jsx",
				"name": "about",
				"extname": ".jsx",
				"basename": "about.jsx",
				"dirname": "",
				"stem": "about",
				"path": "about.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/about.jsx",
				"isAbsolute": false
			},
			"requirePath": "about.jsx",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "cfp.jsx",
				"ext": "jsx",
				"name": "cfp",
				"extname": ".jsx",
				"basename": "cfp.jsx",
				"dirname": "",
				"stem": "cfp",
				"path": "cfp.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/cfp.jsx",
				"isAbsolute": false
			},
			"requirePath": "cfp.jsx",
			"path": "/cfp/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "discounts.jsx",
				"ext": "jsx",
				"name": "discounts",
				"extname": ".jsx",
				"basename": "discounts.jsx",
				"dirname": "",
				"stem": "discounts",
				"path": "discounts.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/discounts.jsx",
				"isAbsolute": false
			},
			"requirePath": "discounts.jsx",
			"path": "/discounts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/home/travis/build/jsis/jsconf.is/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "schedule.jsx",
				"ext": "jsx",
				"name": "schedule",
				"extname": ".jsx",
				"basename": "schedule.jsx",
				"dirname": "",
				"stem": "schedule",
				"path": "schedule.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/schedule.jsx",
				"isAbsolute": false
			},
			"requirePath": "schedule.jsx",
			"path": "/schedule/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "speakers",
				"stem": "_template",
				"path": "speakers/_template.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "speakers/_template.jsx",
			"templatePath": "/speakers/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "alejandro-oviedo.md",
				"ext": "md",
				"name": "alejandro-oviedo",
				"extname": ".md",
				"basename": "alejandro-oviedo.md",
				"dirname": "speakers",
				"stem": "alejandro-oviedo",
				"path": "speakers/alejandro-oviedo.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/alejandro-oviedo.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/alejandro-oviedo.md",
			"path": "/speakers/alejandro-oviedo",
			"data": {
				"title": "Alejandro Oviedo",
				"talk": "Demystifying (JavaScript) engines",
				"path": "/speakers/alejandro-oviedo",
				"type": "speaker",
				"slug": "alejandro-oviedo",
				"twitter": "a0viedo",
				"github": "a0viedo",
				"companyWebsite": "https://github.com/js-squad",
				"company": "JSSquad"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "alex-kaminsky.md",
				"ext": "md",
				"name": "alex-kaminsky",
				"extname": ".md",
				"basename": "alex-kaminsky.md",
				"dirname": "speakers",
				"stem": "alex-kaminsky",
				"path": "speakers/alex-kaminsky.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/alex-kaminsky.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/alex-kaminsky.md",
			"path": "/speakers/alex-kaminsky",
			"data": {
				"title": "Alex Kaminsky",
				"talk": "The First Engineer's Dilemma",
				"path": "/speakers/alex-kaminsky",
				"type": "speaker",
				"slug": "alex-kaminsky",
				"twitter": "alexkaminsky",
				"github": "believeinalex",
				"website": "http://believeinalex.com",
				"companyWebsite": "http://www.reuters.tv/",
				"company": "Reuters TV"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "amy-cheng.md",
				"ext": "md",
				"name": "amy-cheng",
				"extname": ".md",
				"basename": "amy-cheng.md",
				"dirname": "speakers",
				"stem": "amy-cheng",
				"path": "speakers/amy-cheng.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/amy-cheng.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/amy-cheng.md",
			"path": "/speakers/amy-cheng",
			"data": {
				"title": "Amy Cheng",
				"talk": "Recreate Masterpieces of Modern Art with JavaScript!",
				"path": "/speakers/amy-cheng",
				"type": "speaker",
				"slug": "amy-cheng",
				"twitter": "am3thyst",
				"github": "amycheng",
				"website": "http://amycheng.info",
				"companyWebsite": "https://www.brooklynmuseum.org/",
				"company": "Brooklyn Museum"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "azat-mardan.md",
				"ext": "md",
				"name": "azat-mardan",
				"extname": ".md",
				"basename": "azat-mardan.md",
				"dirname": "speakers",
				"stem": "azat-mardan",
				"path": "speakers/azat-mardan.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/azat-mardan.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/azat-mardan.md",
			"path": "/speakers/azat-mardan",
			"data": {
				"title": "Azat Mardan",
				"talk": "You Don't Know Node.js",
				"path": "/speakers/azat-mardan",
				"type": "speaker",
				"slug": "azat-mardan",
				"twitter": "azat_co",
				"github": "azat-co",
				"website": "http://webapplog.com",
				"companyWebsite": "https://www.capitalone.com",
				"company": "Capital One Financial Corporation"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "berglind-osk.md",
				"ext": "md",
				"name": "berglind-osk",
				"extname": ".md",
				"basename": "berglind-osk.md",
				"dirname": "speakers",
				"stem": "berglind-osk",
				"path": "speakers/berglind-osk.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/berglind-osk.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/berglind-osk.md",
			"path": "/speakers/berglind-osk",
			"data": {
				"title": "Berglind Ósk Bergsdóttir",
				"talk": "Feeling like a fake - the Impostor Syndrome",
				"path": "/speakers/berglind-osk",
				"type": "speaker",
				"slug": "berglind-osk",
				"twitter": "berglind0sk",
				"github": "berglind",
				"website": "https://about.me/berglind0sk",
				"companyWebsite": "http://kolibri.is",
				"company": "Kolibri"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "brian-holt.md",
				"ext": "md",
				"name": "brian-holt",
				"extname": ".md",
				"basename": "brian-holt.md",
				"dirname": "speakers",
				"stem": "brian-holt",
				"path": "speakers/brian-holt.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/brian-holt.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/brian-holt.md",
			"path": "/speakers/brian-holt",
			"data": {
				"title": "Brian Holt",
				"talk": "What React/Angular/Ember Devs Can Learn From Elm",
				"path": "/speakers/brian-holt",
				"type": "speaker",
				"slug": "brian-holt",
				"twitter": "holtbt",
				"github": "btholt",
				"companyWebsite": "https://www.netflix.com",
				"company": "Netflix"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "dag-inge-aas.md",
				"ext": "md",
				"name": "dag-inge-aas",
				"extname": ".md",
				"basename": "dag-inge-aas.md",
				"dirname": "speakers",
				"stem": "dag-inge-aas",
				"path": "speakers/dag-inge-aas.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/dag-inge-aas.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/dag-inge-aas.md",
			"path": "/speakers/dag-inge-aas",
			"data": {
				"title": "Dag-Inge Aas",
				"talk": "User experience is everything",
				"path": "/speakers/dag-inge-aas",
				"type": "speaker",
				"slug": "dag-inge-aas",
				"twitter": "daginge",
				"github": "dagingaa",
				"website": "http://daginge.com",
				"companyWebsite": "https://appear.in",
				"company": "appear.in"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "dan-callahan.md",
				"ext": "md",
				"name": "dan-callahan",
				"extname": ".md",
				"basename": "dan-callahan.md",
				"dirname": "speakers",
				"stem": "dan-callahan",
				"path": "speakers/dan-callahan.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/dan-callahan.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/dan-callahan.md",
			"path": "/speakers/dan-callahan",
			"data": {
				"title": "Dan Callahan",
				"talk": "The New Mobile Web: Service Worker, Push, and App Manifests",
				"path": "/speakers/dan-callahan",
				"type": "speaker",
				"slug": "dan-callahan",
				"twitter": "callahad",
				"github": "callahad",
				"website": "http://dancallahan.info",
				"companyWebsite": "https://www.mozilla.org",
				"company": "Mozilla"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "david-blurton.md",
				"ext": "md",
				"name": "david-blurton",
				"extname": ".md",
				"basename": "david-blurton.md",
				"dirname": "speakers",
				"stem": "david-blurton",
				"path": "speakers/david-blurton.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/david-blurton.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/david-blurton.md",
			"path": "/speakers/david-blurton",
			"data": {
				"title": "David Blurton",
				"talk": "Full stack JavaScript development with Docker",
				"path": "/speakers/david-blurton",
				"type": "speaker",
				"slug": "david-blurton",
				"twitter": "davidblurton",
				"github": "davidblurton",
				"website": "http://davidblurton.com/",
				"companyWebsite": "http://takumi.com/",
				"company": "Takumi"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "david-khourshid.md",
				"ext": "md",
				"name": "david-khourshid",
				"extname": ".md",
				"basename": "david-khourshid.md",
				"dirname": "speakers",
				"stem": "david-khourshid",
				"path": "speakers/david-khourshid.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/david-khourshid.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/david-khourshid.md",
			"path": "/speakers/david-khourshid",
			"data": {
				"title": "David Khourshid",
				"talk": "Reactive Animations with CSS Variables",
				"path": "/speakers/david-khourshid",
				"type": "speaker",
				"slug": "david-khourshid",
				"twitter": "davidkpiano",
				"github": "davidkpiano",
				"website": "https://codepen.io/davidkpiano",
				"companyWebsite": "https://www.counsyl.com/",
				"company": "Counsyl"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "david-luecke.md",
				"ext": "md",
				"name": "david-luecke",
				"extname": ".md",
				"basename": "david-luecke.md",
				"dirname": "speakers",
				"stem": "david-luecke",
				"path": "speakers/david-luecke.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/david-luecke.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/david-luecke.md",
			"path": "/speakers/david-luecke",
			"data": {
				"title": "David Luecke",
				"talk": "Meet MySam - An open AI experiment",
				"path": "/speakers/david-luecke",
				"type": "speaker",
				"slug": "david-luecke",
				"twitter": "daffl",
				"github": "daffl"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "denis-rechkunov.md",
				"ext": "md",
				"name": "denis-rechkunov",
				"extname": ".md",
				"basename": "denis-rechkunov.md",
				"dirname": "speakers",
				"stem": "denis-rechkunov",
				"path": "speakers/denis-rechkunov.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/denis-rechkunov.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/denis-rechkunov.md",
			"path": "/speakers/denis-rechkunov",
			"data": {
				"title": "Denis Rechkunov",
				"talk": "Progressive Rendering – how to make your app render sooner",
				"path": "/speakers/denis-rechkunov",
				"type": "speaker",
				"slug": "denis-rechkunov",
				"twitter": "pragmader",
				"github": "pragmader",
				"website": "http://catberry.org",
				"companyWebsite": "https://www.amazon.com",
				"company": "Amazon"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "felipe-ribeiro.md",
				"ext": "md",
				"name": "felipe-ribeiro",
				"extname": ".md",
				"basename": "felipe-ribeiro.md",
				"dirname": "speakers",
				"stem": "felipe-ribeiro",
				"path": "speakers/felipe-ribeiro.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/felipe-ribeiro.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/felipe-ribeiro.md",
			"path": "/speakers/felipe-ribeiro",
			"data": {
				"title": "Felipe Ribeiro",
				"talk": "JavaScript @ Spotify",
				"path": "/speakers/felipe-ribeiro",
				"type": "speaker",
				"slug": "felipe-ribeiro",
				"twitter": "felipernb",
				"github": "felipernb",
				"website": "https://feliperibeiro.com",
				"companyWebsite": "https://www.spotify.com",
				"company": "Spotify"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "heiko-behrens.md",
				"ext": "md",
				"name": "heiko-behrens",
				"extname": ".md",
				"basename": "heiko-behrens.md",
				"dirname": "speakers",
				"stem": "heiko-behrens",
				"path": "speakers/heiko-behrens.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/heiko-behrens.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/heiko-behrens.md",
			"path": "/speakers/heiko-behrens",
			"data": {
				"title": "Heiko Behrens",
				"talk": "JavaScript on tiny, wearable hardware",
				"path": "/speakers/heiko-behrens",
				"type": "speaker",
				"slug": "heiko-behrens",
				"twitter": "hbehrens",
				"github": "hbehrens",
				"website": "http://heikobehrens.net",
				"companyWebsite": "https://www.pebble.com/",
				"company": "Pebble"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "speakers",
				"stem": "index",
				"path": "speakers/index.js",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/index.js",
				"isAbsolute": false
			},
			"requirePath": "speakers/index.js",
			"path": "/speakers/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "jan-lehnardt.md",
				"ext": "md",
				"name": "jan-lehnardt",
				"extname": ".md",
				"basename": "jan-lehnardt.md",
				"dirname": "speakers",
				"stem": "jan-lehnardt",
				"path": "speakers/jan-lehnardt.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/jan-lehnardt.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/jan-lehnardt.md",
			"path": "/speakers/jan-lehnardt",
			"data": {
				"title": "Jan Lehnardt",
				"talk": "undefined",
				"path": "/speakers/jan-lehnardt",
				"type": "speaker",
				"slug": "jan-lehnardt",
				"twitter": "janl",
				"github": "janl",
				"website": "http://writing.jan.io/",
				"companyWebsite": "https://neighbourhood.ie/",
				"company": "Neighbourhoodie Software"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "jenna-zeigen.md",
				"ext": "md",
				"name": "jenna-zeigen",
				"extname": ".md",
				"basename": "jenna-zeigen.md",
				"dirname": "speakers",
				"stem": "jenna-zeigen",
				"path": "speakers/jenna-zeigen.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/jenna-zeigen.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/jenna-zeigen.md",
			"path": "/speakers/jenna-zeigen",
			"data": {
				"title": "Jenna Zeigen",
				"talk": "On How Your Brain is Conspiring Against You Making Good Software",
				"path": "/speakers/jenna-zeigen",
				"type": "speaker",
				"slug": "jenna-zeigen",
				"twitter": "zeigenvector",
				"github": "jennazee",
				"website": "http://jenna.is",
				"companyWebsite": "https://www.digitalocean.com/",
				"company": "DigitalOcean"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "justin-falcone.md",
				"ext": "md",
				"name": "justin-falcone",
				"extname": ".md",
				"basename": "justin-falcone.md",
				"dirname": "speakers",
				"stem": "justin-falcone",
				"path": "speakers/justin-falcone.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/justin-falcone.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/justin-falcone.md",
			"path": "/speakers/justin-falcone",
			"data": {
				"title": "Justin Falcone",
				"talk": "Why is a Guinea Pig Like a Microservice?",
				"path": "/speakers/justin-falcone",
				"type": "speaker",
				"slug": "justin-falcone",
				"twitter": "modernserf",
				"github": "modernserf",
				"website": "http://justinfalcone.com"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "katrina-uychaco.md",
				"ext": "md",
				"name": "katrina-uychaco",
				"extname": ".md",
				"basename": "katrina-uychaco.md",
				"dirname": "speakers",
				"stem": "katrina-uychaco",
				"path": "speakers/katrina-uychaco.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/katrina-uychaco.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/katrina-uychaco.md",
			"path": "/speakers/katrina-uychaco",
			"data": {
				"title": "Katrina Uychaco",
				"talk": "Spinning up an Electron App - Desktop Apps in JavaScript",
				"path": "/speakers/katrina-uychaco",
				"type": "speaker",
				"slug": "katrina-uychaco",
				"twitter": "kuychaco",
				"github": "kuychaco",
				"companyWebsite": "https://github.com",
				"company": "GitHub"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "lin-clark.md",
				"ext": "md",
				"name": "lin-clark",
				"extname": ".md",
				"basename": "lin-clark.md",
				"dirname": "speakers",
				"stem": "lin-clark",
				"path": "speakers/lin-clark.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/lin-clark.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/lin-clark.md",
			"path": "/speakers/lin-clark",
			"data": {
				"title": "Lin Clark",
				"talk": "A cartoon guide to performance in React",
				"path": "/speakers/lin-clark",
				"type": "speaker",
				"slug": "lin-clark",
				"twitter": "linclark",
				"github": "linclark",
				"website": "http://lin-clark.com/",
				"companyWebsite": "https://www.mozilla.org",
				"company": "Mozilla"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "liv-erickson.md",
				"ext": "md",
				"name": "liv-erickson",
				"extname": ".md",
				"basename": "liv-erickson.md",
				"dirname": "speakers",
				"stem": "liv-erickson",
				"path": "speakers/liv-erickson.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/liv-erickson.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/liv-erickson.md",
			"path": "/speakers/liv-erickson",
			"data": {
				"title": "Liv Erickson",
				"talk": "Why you should care about the VR Web - and how to build it!",
				"path": "/speakers/liv-erickson",
				"type": "speaker",
				"slug": "liv-erickson",
				"twitter": "misslivirose",
				"github": "misslivirose",
				"website": "http://livierickson.com",
				"companyWebsite": "https://www.microsoft.com",
				"company": "Microsoft"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "malte-ubl.md",
				"ext": "md",
				"name": "malte-ubl",
				"extname": ".md",
				"basename": "malte-ubl.md",
				"dirname": "speakers",
				"stem": "malte-ubl",
				"path": "speakers/malte-ubl.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/malte-ubl.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/malte-ubl.md",
			"path": "/speakers/malte-ubl",
			"data": {
				"title": "Malte Ubl",
				"talk": "#notalljavascript",
				"path": "/speakers/malte-ubl",
				"type": "speaker",
				"slug": "malte-ubl",
				"twitter": "cramforce",
				"github": "cramforce",
				"website": "http://nonblocking.io",
				"companyWebsite": "https://www.ampproject.org/",
				"company": "AMP Project"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "mariko-kosaka.md",
				"ext": "md",
				"name": "mariko-kosaka",
				"extname": ".md",
				"basename": "mariko-kosaka.md",
				"dirname": "speakers",
				"stem": "mariko-kosaka",
				"path": "speakers/mariko-kosaka.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/mariko-kosaka.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/mariko-kosaka.md",
			"path": "/speakers/mariko-kosaka",
			"data": {
				"title": "Mariko Kosaka",
				"talk": "Making a Robot Eye with JavaScript - or Magic of Computer Vision Unraveled",
				"path": "/speakers/mariko-kosaka",
				"type": "speaker",
				"slug": "mariko-kosaka",
				"twitter": "kosamari",
				"github": "kosamari",
				"website": "http://kosamari.com",
				"companyWebsite": "http://scripto.org/",
				"company": "Scripto"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "max-goodman.md",
				"ext": "md",
				"name": "max-goodman",
				"extname": ".md",
				"basename": "max-goodman.md",
				"dirname": "speakers",
				"stem": "max-goodman",
				"path": "speakers/max-goodman.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/max-goodman.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/max-goodman.md",
			"path": "/speakers/max-goodman",
			"data": {
				"title": "Max Goodman",
				"talk": "Bicycle.js",
				"path": "/speakers/max-goodman",
				"type": "speaker",
				"slug": "max-goodman",
				"twitter": "chromakode",
				"github": "chromakode",
				"website": "http://chromakode.com"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "mihai-cirlanaru.md",
				"ext": "md",
				"name": "mihai-cirlanaru",
				"extname": ".md",
				"basename": "mihai-cirlanaru.md",
				"dirname": "speakers",
				"stem": "mihai-cirlanaru",
				"path": "speakers/mihai-cirlanaru.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/mihai-cirlanaru.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/mihai-cirlanaru.md",
			"path": "/speakers/mihai-cirlanaru",
			"data": {
				"title": "Mihai Cîrlănaru",
				"talk": "Speech Recognition on the Web",
				"path": "/speakers/mihai-cirlanaru",
				"type": "speaker",
				"slug": "mihai-cirlanaru",
				"twitter": "mcirlanaru",
				"github": "mihai",
				"website": "http://mihaicirlanaru.com",
				"companyWebsite": "https://www.hudl.com/",
				"company": "Hudl"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "myles-borins.md",
				"ext": "md",
				"name": "myles-borins",
				"extname": ".md",
				"basename": "myles-borins.md",
				"dirname": "speakers",
				"stem": "myles-borins",
				"path": "speakers/myles-borins.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/myles-borins.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/myles-borins.md",
			"path": "/speakers/myles-borins",
			"data": {
				"title": "Myles Borins",
				"talk": "On left-pad and empathy: understanding human connection",
				"path": "/speakers/myles-borins",
				"type": "speaker",
				"slug": "myles-borins",
				"twitter": "TheAlphaNerd",
				"github": "TheAlphaNerd"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "nick-doiron.md",
				"ext": "md",
				"name": "nick-doiron",
				"extname": ".md",
				"basename": "nick-doiron.md",
				"dirname": "speakers",
				"stem": "nick-doiron",
				"path": "speakers/nick-doiron.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/nick-doiron.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/nick-doiron.md",
			"path": "/speakers/nick-doiron",
			"data": {
				"title": "Nick Doiron",
				"talk": "If One Laptop per Child were started today, how JavaScript-y would it be?",
				"path": "/speakers/nick-doiron",
				"type": "speaker",
				"slug": "nick-doiron",
				"twitter": "mapmeld",
				"github": "mapmeld",
				"website": "http://mapmeld.com",
				"companyWebsite": "http://asiafoundation.org/",
				"company": "The Asia Foundation"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "raquel-velez.md",
				"ext": "md",
				"name": "raquel-velez",
				"extname": ".md",
				"basename": "raquel-velez.md",
				"dirname": "speakers",
				"stem": "raquel-velez",
				"path": "speakers/raquel-velez.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/raquel-velez.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/raquel-velez.md",
			"path": "/speakers/raquel-velez",
			"data": {
				"title": "Raquel Vélez",
				"talk": "undefined",
				"path": "/speakers/raquel-velez",
				"type": "speaker",
				"slug": "raquel-velez",
				"twitter": "rockbot",
				"github": "rockbot",
				"website": "https://rckbt.me/",
				"companyWebsite": "https://www.npmjs.com/",
				"company": "npm"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "seth-samuel.md",
				"ext": "md",
				"name": "seth-samuel",
				"extname": ".md",
				"basename": "seth-samuel.md",
				"dirname": "speakers",
				"stem": "seth-samuel",
				"path": "speakers/seth-samuel.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/seth-samuel.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/seth-samuel.md",
			"path": "/speakers/seth-samuel",
			"data": {
				"title": "Seth Samuel",
				"talk": "Arbitrary Computation on the GPU Using WebGL",
				"path": "/speakers/seth-samuel",
				"type": "speaker",
				"slug": "seth-samuel",
				"twitter": "sethfsamuel",
				"github": "sethfsamuel",
				"companyWebsite": "https://www.airtime.com/",
				"company": "Airtime"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "tilde-ann-thurium.md",
				"ext": "md",
				"name": "tilde-ann-thurium",
				"extname": ".md",
				"basename": "tilde-ann-thurium.md",
				"dirname": "speakers",
				"stem": "tilde-ann-thurium",
				"path": "speakers/tilde-ann-thurium.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/tilde-ann-thurium.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/tilde-ann-thurium.md",
			"path": "/speakers/tilde-ann-thurium",
			"data": {
				"title": "Tilde Ann Thurium",
				"talk": "Pivoting to React, at scale",
				"path": "/speakers/tilde-ann-thurium",
				"type": "speaker",
				"slug": "tilde-ann-thurium",
				"twitter": "annthurium",
				"github": "annthurium",
				"companyWebsite": "https://www.pinterest.com",
				"company": "Pinterest"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "tryggvi-gylfason.md",
				"ext": "md",
				"name": "tryggvi-gylfason",
				"extname": ".md",
				"basename": "tryggvi-gylfason.md",
				"dirname": "speakers",
				"stem": "tryggvi-gylfason",
				"path": "speakers/tryggvi-gylfason.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/tryggvi-gylfason.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/tryggvi-gylfason.md",
			"path": "/speakers/tryggvi-gylfason",
			"data": {
				"title": "Tryggvi Gylfason",
				"talk": "This will flow your mind",
				"path": "/speakers/tryggvi-gylfason",
				"type": "speaker",
				"slug": "tryggvi-gylfason",
				"twitter": "tryggvigy",
				"github": "tryggvigy",
				"companyWebsite": "https://quizup.com",
				"company": "QuizUp"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "tsubomi-imamura.md",
				"ext": "md",
				"name": "tsubomi-imamura",
				"extname": ".md",
				"basename": "tsubomi-imamura.md",
				"dirname": "speakers",
				"stem": "tsubomi-imamura",
				"path": "speakers/tsubomi-imamura.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/tsubomi-imamura.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/tsubomi-imamura.md",
			"path": "/speakers/tsubomi-imamura",
			"data": {
				"title": "Tsubomi Imamura",
				"talk": "Breaking the monolith with Node and Docker at Netflix",
				"path": "/speakers/tsubomi-imamura",
				"type": "speaker",
				"slug": "tsubomi-imamura",
				"github": "leitsubomi",
				"companyWebsite": "https://www.netflix.com",
				"company": "Netflix"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "visnu-pitiyanuvath.md",
				"ext": "md",
				"name": "visnu-pitiyanuvath",
				"extname": ".md",
				"basename": "visnu-pitiyanuvath.md",
				"dirname": "speakers",
				"stem": "visnu-pitiyanuvath",
				"path": "speakers/visnu-pitiyanuvath.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/visnu-pitiyanuvath.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/visnu-pitiyanuvath.md",
			"path": "/speakers/visnu-pitiyanuvath",
			"data": {
				"title": "Visnu Pitiyanuvath",
				"talk": "HSL: The RGB You've Been Waiting For",
				"path": "/speakers/visnu-pitiyanuvath",
				"type": "speaker",
				"slug": "visnu-pitiyanuvath",
				"twitter": "visnup",
				"github": "visnup"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "vitaly-friedman.md",
				"ext": "md",
				"name": "vitaly-friedman",
				"extname": ".md",
				"basename": "vitaly-friedman.md",
				"dirname": "speakers",
				"stem": "vitaly-friedman",
				"path": "speakers/vitaly-friedman.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/vitaly-friedman.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/vitaly-friedman.md",
			"path": "/speakers/vitaly-friedman",
			"data": {
				"title": "Vitaly Friedman",
				"talk": "Reactive Animations with CSS Variables",
				"path": "/speakers/vitaly-friedman",
				"type": "speaker",
				"slug": "vitaly-friedman",
				"twitter": "smashingmag",
				"companyWebsite": "https://www.smashingmagazine.com",
				"company": "Smashing Magazine"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tickets.jsx",
				"ext": "jsx",
				"name": "tickets",
				"extname": ".jsx",
				"basename": "tickets.jsx",
				"dirname": "",
				"stem": "tickets",
				"path": "tickets.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/tickets.jsx",
				"isAbsolute": false
			},
			"requirePath": "tickets.jsx",
			"path": "/tickets/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "trips.jsx",
				"ext": "jsx",
				"name": "trips",
				"extname": ".jsx",
				"basename": "trips.jsx",
				"dirname": "",
				"stem": "trips",
				"path": "trips.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/trips.jsx",
				"isAbsolute": false
			},
			"requirePath": "trips.jsx",
			"path": "/trips/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "venue",
				"base": "_venue.md",
				"ext": "md",
				"name": "_venue",
				"extname": ".md",
				"basename": "_venue.md",
				"dirname": "venue",
				"stem": "_venue",
				"path": "venue/_venue.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/venue/_venue.md",
				"isAbsolute": false
			},
			"requirePath": "venue/_venue.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "venue",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "venue",
				"stem": "index",
				"path": "venue/index.js",
				"absolute": "/home/travis/build/jsis/jsconf.is/venue/index.js",
				"isAbsolute": false
			},
			"requirePath": "venue/index.js",
			"path": "/venue/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 363
 ** module chunks = 0
 **/